module.exports = __webpack_public_path__ + "img/elementlengths_jak.565007b6.png";